export default {
  SHIFT: 'SHIFT',
}
